export const POWERSIMM_COPY = 'POWERSIMM_COPY';
export const POWERSIMM_UPDATE = 'POWERSIMM_UPDATE';
export const POWERSIMM_INSERTDELETE = 'POWERSIMM_INSERTDELETE';
export const POWERSIMM_MASTERUPDATE = 'POWERSIMM_MASTERUPDATE';
export const POWERSIMM_MASTERINSERTDELETE = 'POWERSIMM_MASTERINSERTDELETE';
export const POWERSIMM_STUDYCREATE = 'POWERSIMM_STUDYCREATE';
export const POWERSIMM_STUDYDELETE = 'POWERSIMM_STUDYDELETE';
export const POWERSIMM_ADMIN = 'POWERSIMM_ADMIN';
export const INTERNAL_ADMIN = 'INTERNAL_ADMIN';
